<template>
  <div class="invoice-comment">
    <p class="invoice-comment__comment">
      {{comment}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'InvoiceComment',
  props: {
    /**
     * @description Комментарий.
     * @type String
     */
    comment: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.invoice-comment {
  text-align: center;
  font-size: 18px;
  max-width: 375px;
  max-height: 200px;
  &__comment {
    max-width: 350px;
    max-height: 190px;
  }
}
</style>
